import createAxios from 'App/utils/createAxios';

const { protocol, host, port } = window.location;
const therigyURL = `${protocol}//${host}${port ? `:${port}` : ''}`;
const phpRequest = createAxios({
    baseURL: `${therigyURL}/app.api.php/api`,
});
const noToastPhpRequest = createAxios({ baseURL: `${therigyURL}/app.api.php/api` }, { shouldShowToastFn: () => false });

function getQuestionLinkOptions() {
    return phpRequest.get(`/assessment/questions/linkoptions`);
}

function getQuestions(assessmentId, params = {}) {
    return phpRequest.get(`/assessment/questions/${assessmentId}`, { params });
}

function getSingleQuestion(questionId) {
    return noToastPhpRequest.get(`/assessment/question/${questionId}`);
}

function getQuestionLinks(assessmentId) {
    return phpRequest.get(`/assessment/questions/${assessmentId}/links`);
}

function saveQuestions(assessmentId, questions) {
    return phpRequest.post(`/assessment/questions/${assessmentId}`, {
        questionJson: JSON.stringify(questions),
    });
}

export { getQuestionLinkOptions, getQuestions, getSingleQuestion, getQuestionLinks, saveQuestions };
